import { render, staticRenderFns } from "./ClientAccountChangeLogsDetailsView.vue?vue&type=template&id=1b986724"
import script from "./ClientAccountChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./ClientAccountChangeLogsDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports